/**
 * Created by sung on 2017-04-20.
 */
import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslatePipe} from "./translate.pipe";

@NgModule({
    declarations:[TranslatePipe],
    imports:[CommonModule],
    exports:[TranslatePipe]
})

export class TranslatePipeMoudle{}


// WEBPACK FOOTER //
// ./src/app/translate/translate.module.pipe.ts